// extracted by mini-css-extract-plugin
module.exports = {"btn":"BtnPanier_btn__hGszb","isPanierOpen":"BtnPanier_isPanierOpen__2-20v","svg":"BtnPanier_svg__1i0ZE"};